import * as React from "react";
import Svg, { Path } from "react-native-svg";

function CLShare(props) {
  return (
    <Svg width={21} height={21} viewBox="0 0 21 21" fill="none" {...props}>
      <Path
        d="M2.625 4.375h1.75v-1.75c-.962 0-1.75.788-1.75 1.75zm0 7h1.75v-1.75h-1.75v1.75zm3.5 7h1.75v-1.75h-1.75v1.75zm-3.5-10.5h1.75v-1.75h-1.75v1.75zm8.75-5.25h-1.75v1.75h1.75v-1.75zm5.25 0v1.75h1.75c0-.962-.788-1.75-1.75-1.75zm-12.25 15.75v-1.75h-1.75c0 .962.788 1.75 1.75 1.75zm-1.75-3.5h1.75v-1.75h-1.75v1.75zm5.25-12.25h-1.75v1.75h1.75v-1.75zm1.75 15.75h1.75v-1.75h-1.75v1.75zm7-7h1.75v-1.75h-1.75v1.75zm0 7c.962 0 1.75-.788 1.75-1.75h-1.75v1.75zm0-10.5h1.75v-1.75h-1.75v1.75zm0 7h1.75v-1.75h-1.75v1.75zm-3.5 3.5h1.75v-1.75h-1.75v1.75zm0-14h1.75v-1.75h-1.75v1.75zm-7 10.5h8.75v-8.75h-8.75v8.75zm1.75-7h5.25v5.25h-5.25v-5.25z"
        fill="#fff"
      />
    </Svg>
  );
}

export default CLShare;
